import {Sprite, Texture} from 'pixi.js';
import {TextureUrlLoader} from '../../../../../../utils/TextureUrlLoader';
import {Pivot} from '../../../../../../utils/Pivot';

export class MicIndicator extends Sprite
{
    icon: Sprite | undefined;

    constructor() {
        super();

        this.initialize();
    }

    private async initialize() {

        let iconTexture: Texture | null = await TextureUrlLoader.load('/images/video_seats/name_mic.svg');
        this.icon = new Sprite(iconTexture!);

        this.addChild(this.icon);

        Pivot.centerPivot(this.icon);
    }
}
